import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { iconSize } from '../../../../../../constants/icon.constants';
import Icon from '../../../../../@shared/icon';
import { TGDPRPopupCheckboxSection } from '../../../../types/gdprConsentField.types';

const CheckboxSection: FC<TGDPRPopupCheckboxSection> = ({ policy, updateData, checked }) => {
  return (
    <div className="gdpr-popup__checkbox-section">
      <label>
        <input
          id={policy.id.toString()}
          type="checkbox"
          required={policy.required}
          checked={checked}
          onChange={(e) => updateData(policy.id, e.target.checked)}
        />
        <label htmlFor={policy.id.toString()} className="gdpr-popup__checkbox-section--wrapper">
          <Icon
            iconName={checked ? 'action-checkbox-checked' : 'action-checkbox-default'}
            size={iconSize.dsk}
            extraClassName="gdpr-popup__checkbox-section--icon "
          />
          <RichText tag="span" field={{ value: policy.description }} className="gdpr-popup__checkbox-section--label" />
        </label>
      </label>
    </div>
  );
};

export default CheckboxSection;
